import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import ua from '@tencent/docs-user-agent';

var EXCEPTION_CODES = [12100, 12105, 12104, -20002, -20036];

function getQuery(url, key) {
  var m = url.match(new RegExp("(\\?|&)".concat(key, "=([^&]*?)(#|&|$)")));
  return !m ? '' : decodeURIComponent(m[2]);
}

function addQuery(url, key, value) {
  var query = getQuery(url, key);

  if (query) {
    return url.replace(new RegExp("(\\?|&)".concat(key, "=").concat(query)), "$1".concat(key, "=").concat(value));
  }

  return "".concat(url).concat(url.indexOf('?') > -1 ? '&' : '?').concat(key, "=").concat(value);
}
function needLogin(code) {
  return EXCEPTION_CODES.indexOf(code) > -1;
}
function tryLogin() {
  return _tryLogin.apply(this, arguments);
}

function _tryLogin() {
  _tryLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getGlobal$tdocs2, _getGlobal$tdocs2$doc;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!ua.isWxWork) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", (_getGlobal$tdocs2 = getGlobal().tdocs) === null || _getGlobal$tdocs2 === void 0 ? void 0 : (_getGlobal$tdocs2$doc = _getGlobal$tdocs2.docLogin) === null || _getGlobal$tdocs2$doc === void 0 ? void 0 : _getGlobal$tdocs2$doc.call(_getGlobal$tdocs2));

          case 2:
            return _context.abrupt("return");

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _tryLogin.apply(this, arguments);
}

var RETRY_QUERY = '_retry';
var canRetryMore = function canRetryMore(request) {
  var _getGlobal$tdocs;

  // doc_net 做了续票，我们就不处理了
  if (getGlobal().hadIntercepted) return false;
  if (typeof ((_getGlobal$tdocs = getGlobal().tdocs) === null || _getGlobal$tdocs === void 0 ? void 0 : _getGlobal$tdocs.docLogin) !== 'function') return false;
  var url = request === null || request === void 0 ? void 0 : request.responseURL;

  if (typeof url !== 'string') {
    return false;
  }

  return !getQuery(url, RETRY_QUERY);
};
function getGlobal() {
  if (typeof window !== 'undefined') {
    return window;
  }

  return {};
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function doLogin(_x, _x2) {
  return _doLogin.apply(this, arguments);
}
/**
 * @deprecated
 * 组合使用 `needLogin` 和 `doLogin`，如果需要登录，就登录后重试一次
 */

function _doLogin() {
  _doLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(res, ins) {
    var url;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!canRetryMore(res.request)) {
              _context2.next = 6;
              break;
            }

            if (!res.config.url) {
              _context2.next = 6;
              break;
            }

            _context2.next = 4;
            return tryLogin();

          case 4:
            url = addQuery(res.config.url, RETRY_QUERY, 1);
            return _context2.abrupt("return", ins.request(_objectSpread(_objectSpread({}, res.config), {}, {
              url: url
            })));

          case 6:
            return _context2.abrupt("return", Promise.reject(res));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _doLogin.apply(this, arguments);
}

var checkLogin = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(retcode, res, ins) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!needLogin(retcode)) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return doLogin(res, ins);

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
            return _context.abrupt("return", res);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function checkLogin(_x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

export { checkLogin, doLogin, needLogin };
